import { render } from "./registration.vue?vue&type=template&id=7ea81881"
import script from "./registration.js?vue&type=script&lang=js"
export * from "./registration.js?vue&type=script&lang=js"

import "./registration.vue?vue&type=style&index=0&id=7ea81881&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__